// «UI nuova» switch (docs/ui-nuova/MIGRATION-PLAN.md §1.1, step M9 booking).
// The booking app opts in: enable() makes the stored per-device choice
// (localStorage `beebee_ui`) or a `?ui=new|old` in the URL apply, re-stamps
// html[data-ui] (the inline script in index.html already did it before boot,
// so no flash) and tags Sentry. There is no switch here (patients never see
// one): in production the beebee-base service:ui preview gate decides, and the
// tenant it needs is pushed by routes/application.js setupController
// (ui.setTenant of the public organization slug). Never look up service:session
// from here: it would instantiate the real session before the test mocks.
export function initialize(appInstance) {
  appInstance.lookup('service:ui')?.enable();
}

export default {
  initialize,
};
